
const platform = import.meta.env.VITE_PLATFORM || '';
const config = {
    ApiUrl: 'https://localhost:44375/api',
    LoginUrl: '/user/login',
    SignUpUrl: '/user/signup',
    PersonalInformation: '/user/profile/personal',
    NextOfKinInformation: '/user/profile/nextofkin',
    PasswordResetUrl: '/user/account/resetpassword/{email}',
    CompletePasswordResetUrl: '/user/account/completeresetpassword',
    ConfirmEmailUrl: '/user/account/confirmemail',
    RoomDetailUrl: '/listing/details/{reference}',
    CreateListingUrl: '/listing/new',
    FetchHostListings: '/listing/fetch/{hostId}/{page}/{size}',
    FetchRequestUrl: '/request/{page}/{size}',
    AcceptRequestUrl: '/request/accept/{requestId}',
    CancelRequestUrl: '/request/cancel/{requestId}',
    RejectRequestUrl: '/request/reject/{requestId}',
    SubscriberSubcriptionHistoryUrl: '/subscription/subscriber/history',
    SubscriberSubcriptionSummaryUrl: '/subscription/subscriber/summary/{subscriberId}',
    SubscriberExtendSubscription: '/subscription/extend/{subscriptionId}/{numberOfMonths}',
    FetchCurrentSubscription: '/subscription/subcriber/currentsubscription/{subscriberId}',
    GenerateInvoiceFromSubscription: '/invoice/generatefromsubscription/{subscriptionId}',
    GenerateInvoiceFromRequest: '/invoice/generatefromrequest/{requestId}',
    FetchInvoiceUrl: '/invoice/details/{invoiceNumber}',
    SubscriberRequests: 'request/subrequests',
    HostSubscriptionSummaryUrl: '/subscription/host/summary/{hostId}',
    FetchListingUrl: '/listing/search/{page}/{size}',
    ListingSummaryUrl: '/listing/summary',
    RequestSummaryUrl: '/request/summary',
    FetchRecentRequestUrl: '/request/fetchrecentrequest',
    SetAvailabilityUrl: '/request/set-availability/{requestId}',
    ConfirmAvailabilityUrl: '/request/confirm-availability',
    SimilarListings: '/listing/similarlisting/{reference}',
    SaveListing: '/listing/save/{reference}',
    CloseListing: '/listing/close/{reference}',
    EditListing: '/listing/edit/{hostId}',
    EditHostListing: '/listing/edit/{hostId}',
    DeleteHostListing: '/listing/delete/{reference}',
    JoinWaitListUrl: '/listing/waitlist',
    HomePageTopHomesUrl: '/listing/tophomes',
    HomePageTopCitiesUrl: '/listing/topcities',
    AddBankUrl: '/user/payment/bank/add',
    DeleteBankUrl: '/user/payment/bank/remove/{accountId}',
    FetchBankDetails: '/user/payment/bank/details',
    FetchBanks: '/user/payment/banks/{countryCode}',
    CreateRequestUrl: '/request/createrequest',
    SaveInvoiceUrl: '/invoice/save',
    MarkRequestAsPaidUrl: '/request/mark-request-as-paid/{requestId}',
    GetViewingByIdUrl: '/request/get-viewing/{requestId}',
    UpdateViewingCommentUrl: '/request/viewing/comment',
    ApproveFinancierRequestUrl: '/request/financier/approve/{requestId}',
    RejectFinancierRequestUrl: '/request/financier/reject/{requestId}',
    DisburseFinancierRequestUrl: '/request/financier/disburse/{requestId}',

    AWS: {
        AccessKey: 'AKIAIEKUZGZFSW56HIRQ',
        SecretKey: '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',
        S3: {
            bucketName: 'muster-images',
            accelerationEndPoint: 'muster-images.s3-accelerate.amazonaws.com',
            bucketRegion: 'us-west-2',
        },
        Cognito: {
            identityPoolId: 'us-west-2:2b9e128d-fa08-4e1d-a340-57527a424a27',
            region: 'us-west-2'
        }
    },
    Payments: {
        Flutterwave: {
            BaseUrl: 'https://checkout.flutterwave.com/v3.js',
            PublicKey: 'FLWPUBK_TEST-ab1dfc2c271945f08d15993d88320422-X',
            VerifyInvoiceUrl: '/invoice/verify/flutterwave/{invoiceNumber}'
        },
        BudPay: {
            VerifyInvoiceUrl: '/invoice/verify/flutterwave/{invoiceNumber}'

        }
    }
};

switch (platform) {
    case "production":
        config.ApiUrl = 'https://api.muster.africa/api';
        break;
    case "staging":
        config.ApiUrl = 'https://api-staging.usesheltr.com/api';
        break;
    default:
        break;
}

export default config;